<template>
  <div class="p-6">
    We're sorry, an unexpected error occurred while loading this page.
    <navigation_back class="mt-2"/>
  </div>
</template>

<script setup>
import navigation_back from '@/components/widgetcomponents/navigation_back.vue'

</script>